import React from 'react'
import { SSOLogin } from './SSOLogin'
import { LoginSelector } from './LoginSelector'
import { LoginPageWrapper } from './components/LoginPageWrapper'

export function LoginPage(): React.JSX.Element {
  const [error, setError] = React.useState('')

  const getContent = (): React.JSX.Element => {
    if (window.location.hostname === process.env.REACT_APP_SWAMID_HOST) {
      return <SSOLogin setError={setError} error={error} />
    }
    return <LoginSelector setError={setError} />
  }
  return <LoginPageWrapper error={error}>{getContent()}</LoginPageWrapper>
}
